<div
  class="filter-item"
  [matMenuTriggerFor]="marketsFilter"
  #trigger="matMenuTrigger"
  [ngClass]="{ active: checkedCount > 0 || isOpen }"
  (menuOpened)="isOpen = true"
  (menuClosed)="isOpen = false"
>
  <span>
    Markets
    <span class="md:hidden lg:inline" *ngIf="checkedCount > 0"
      >({{ checkedCount }})</span
    >
  </span>
  <app-shared-icon name="chevron-down-2"></app-shared-icon>
</div>

<mat-menu
  #marketsFilter="matMenu"
  class="filters-mat-menu filters-states-mat-menu"
  xPosition="after"
>
  <div
    class="filter-dropdown"
    (click)="$event.stopPropagation()"
    (keydown)="$event.stopPropagation()"
  >
    <ul>
      <li class="toggler">
        <mat-checkbox
          labelPosition="before"
          class="example-margin"
          color="primary"
          [checked]="allSelected"
          (change)="toggleAllSelection()"
          >{{ allSelected ? 'Deselect' : 'Select' }} all</mat-checkbox
        >
      </li>
      <li class="search-markets">
        <input
          placeholder="Search markets..."
          [(ngModel)]="searchTerm"
          (ngModelChange)="filterMarkets()"
        />
      </li>
      <li *ngFor="let market of filteredMarkets">
        <mat-checkbox
          labelPosition="before"
          class="example-margin"
          color="primary"
          [(ngModel)]="checkedMarkets[market.abbr]"
          (ngModelChange)="onChangeStates()"
          [value]="market.abbr"
          >{{ market.name }}</mat-checkbox
        >
      </li>
      <li *ngIf="filteredMarkets.length === 0">
        <div class="empty-results">Nothing found for "{{ searchTerm }}"</div>
      </li>
    </ul>

    <app-filter-v2-buttons
      (resetAction)="resetMarkets()"
      (applyAction)="closeMenu()"
    ></app-filter-v2-buttons>
  </div>
</mat-menu>
